import { initializeMentionAutocompletes } from './mention-autocomplete';

const initializeLiveMapMessageDrawer = () => {
    const drawer =
        document.querySelector(
            '[data-live-map-message-drawer]'
        );

    if (
        !drawer
        || drawer.dataset.initialized
            === 'true'
    ) {
        return;
    }

    drawer.dataset.initialized = 'true';

    const backdrop =
        document.querySelector(
            '[data-live-map-message-drawer-backdrop]'
        );

    const closeButton =
        drawer.querySelector(
            '[data-live-map-message-close]'
        );

    const muteButton =
        drawer.querySelector(
            '[data-live-map-message-mute]'
        );

    const findMemberButton =
        drawer.querySelector(
            '[data-live-map-message-find-member]'
        );

    const navigateMemberButton =
        drawer.querySelector(
            '[data-live-map-message-navigate-member]'
        );

    const profileLink =
        drawer.querySelector(
            '[data-live-map-message-profile]'
        );

    const searchToggle =
        drawer.querySelector(
            '[data-live-map-message-search-toggle]'
        );

    const searchPanel =
        drawer.querySelector(
            '[data-live-map-message-search-panel]'
        );

    const searchForm =
        drawer.querySelector(
            '[data-live-map-message-search-form]'
        );

    const searchInput =
        drawer.querySelector(
            '[data-live-map-message-search-input]'
        );

    const searchClose =
        drawer.querySelector(
            '[data-live-map-message-search-close]'
        );

    const searchResults =
        drawer.querySelector(
            '[data-live-map-message-search-results]'
        );

    const backButton =
        drawer.querySelector(
            '[data-live-map-message-back]'
        );

    const openButtons =
        document.querySelectorAll(
            '[data-live-map-messages-open]'
        );

    const inboxUrl =
        drawer.dataset.inboxUrl;

    const title =
        drawer.querySelector(
            '[data-live-map-message-title]'
        );

    const subtitle =
        drawer.querySelector(
            '[data-live-map-message-subtitle]'
        );

    const presence =
        drawer.querySelector(
            '[data-live-map-message-presence]'
        );

    const avatar =
        drawer.querySelector(
            '[data-live-map-message-avatar]'
        );

    const inboxFilters =
        drawer.querySelector(
            '[data-live-map-message-inbox-filters]'
        );

    const inboxFilterButtons =
        drawer.querySelectorAll(
            '[data-live-map-message-inbox-filter]'
        );

    const inboxFilterStrip =
        drawer.querySelector(
            '[data-live-map-message-inbox-filter-strip]'
        );

    const unreadFilterCount =
        drawer.querySelector(
            '[data-live-map-message-unread-count]'
        );

    const unreadOnMapCount =
        drawer.querySelector(
            '[data-live-map-message-unread-on-map-count]'
        );

    const onMapCount =
        drawer.querySelector(
            '[data-live-map-message-on-map-count]'
        );

    const messageList =
        drawer.querySelector(
            '[data-live-map-message-list]'
        );

    const loading =
        drawer.querySelector(
            '[data-live-map-message-loading]'
        );

    const newMessageBar =
        drawer.querySelector(
            '[data-live-map-message-new-bar]'
        );

    const newMessageButton =
        drawer.querySelector(
            '[data-live-map-message-new-button]'
        );

    const newMessageLabel =
        drawer.querySelector(
            '[data-live-map-message-new-label]'
        );

    const readonlyNotice =
        drawer.querySelector(
            '[data-live-map-message-readonly]'
        );

    const form =
        drawer.querySelector(
            '[data-live-map-message-form]'
        );

    const input =
        drawer.querySelector(
            '[data-live-map-message-input]'
        );

    const sendButton =
        drawer.querySelector(
            '[data-live-map-message-send]'
        );

    const attachmentQueue =
        form?.querySelector(
            '[data-message-attachment-queue]'
        );

    const attachmentInput =
        form?.querySelector(
            '[data-message-attachment-input]'
        );

    const typingIndicator =
        drawer.querySelector(
            '[data-live-map-message-typing]'
        );

    const quickReplyButtons =
        drawer.querySelectorAll(
            '[data-live-map-message-quick-reply]'
        );

    const replyPreview =
        drawer.querySelector(
            '[data-live-map-message-reply-preview]'
        );

    const replyLabel =
        drawer.querySelector(
            '[data-live-map-message-reply-label]'
        );

    const replyText =
        drawer.querySelector(
            '[data-live-map-message-reply-text]'
        );

    const replyIdInput =
        drawer.querySelector(
            '[data-live-map-message-reply-id]'
        );

    const replyCancel =
        drawer.querySelector(
            '[data-live-map-message-reply-cancel]'
        );

    const error =
        drawer.querySelector(
            '[data-live-map-message-error]'
        );

    const fullLink =
        drawer.querySelector(
            '[data-live-map-message-full-link]'
        );

    let activeConversation = null;
    let lastOpenedConversationId = null;
    let activeInboxFilter = 'all';
    let latestInboxPayload = null;
    let inboxScrollTop = 0;
    let restoreInboxScrollOnRender = false;
    let activeMode = 'closed';
    let pollTimer = null;
    let loadingConversation = false;
    let loadingInbox = false;
    let sending = false;
    let latestMessageId = 0;
    let oldestMessageId = 0;
    let hasOlderMessages = false;
    let readThroughMessageId = 0;
    let loadingHistory = false;
    let searching = false;
    let searchOpen = false;
    let pendingNewMessageCount = 0;
    let visibleMemberMarkerIds =
        new Set();

    let navigableMemberMarkerIds =
        new Set();

    let visibleMemberPresence =
        new Map();

    let lastTypingPingAt = 0;
    let typingPollTimer = null;

    const hideTypingIndicator = () => {
        if (!typingIndicator) {
            return;
        }

        typingIndicator.textContent = '';
        typingIndicator.classList.add('hidden');
    };

    const pollTypingStatus = async () => {
        if (
            !activeConversation
            || !activeConversation.typingStatusUrl
            || document.visibilityState === 'hidden'
        ) {
            hideTypingIndicator();
            return;
        }

        try {
            const response = await fetch(
                activeConversation.typingStatusUrl,
                {
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cache: 'no-store',
                }
            );

            if (!response.ok) {
                return;
            }

            const payload = await response.json();

            if (
                payload.typing
                && payload.member_name
            ) {
                typingIndicator.textContent =
                    `${payload.member_name} is typing…`;

                typingIndicator.classList.remove(
                    'hidden'
                );

                return;
            }

            hideTypingIndicator();
        } catch {
            // Typing status is best-effort.
        }
    };

    const sendTypingPing = async () => {
        if (
            !activeConversation
            || !activeConversation.typingUpdateUrl
            || !input?.value.trim()
        ) {
            return;
        }

        const now = Date.now();

        if (now - lastTypingPingAt < 2500) {
            return;
        }

        lastTypingPingAt = now;

        const csrfToken =
            document.querySelector(
                'meta[name="csrf-token"]'
            )?.content;

        try {
            await fetch(
                activeConversation.typingUpdateUrl,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        ...(csrfToken
                            ? {
                                'X-CSRF-TOKEN': csrfToken,
                            }
                            : {}),
                    },
                }
            );
        } catch {
            // Typing notifications are best-effort.
        }
    };

    const stopTypingPolling = () => {
        if (typingPollTimer) {
            window.clearInterval(
                typingPollTimer
            );

            typingPollTimer = null;
        }

        hideTypingIndicator();
    };

    const startTypingPolling = () => {
        stopTypingPolling();

        pollTypingStatus();

        typingPollTimer =
            window.setInterval(
                pollTypingStatus,
                2000
            );
    };

    const setError = (text = '') => {
        if (!error) {
            return;
        }

        error.textContent = text;

        error.classList.toggle(
            'hidden',
            !text
        );

        error.classList.toggle(
            'border-rose-300',
            Boolean(text)
        );

        error.classList.toggle(
            'bg-rose-50',
            Boolean(text)
        );

        error.classList.toggle(
            'text-rose-700',
            Boolean(text)
        );

        error.classList.toggle(
            'dark:border-rose-400/30',
            Boolean(text)
        );

        error.classList.toggle(
            'dark:bg-rose-400/10',
            Boolean(text)
        );

        error.classList.toggle(
            'dark:text-rose-200',
            Boolean(text)
        );
    };

    const isNearBottom = () => {
        if (!messageList) {
            return true;
        }

        return (
            messageList.scrollHeight
            - messageList.scrollTop
            - messageList.clientHeight
        ) < 90;
    };

    const scrollToBottom = () => {
        if (!messageList) {
            return;
        }

        messageList.scrollTop =
            messageList.scrollHeight;
    };

    const updateNewMessageUi = () => {
        if (
            !newMessageBar
            || !newMessageLabel
        ) {
            return;
        }

        const visible =
            activeMode === 'conversation'
            && pendingNewMessageCount > 0
            && !isNearBottom();

        newMessageBar.classList.toggle(
            'hidden',
            !visible
        );

        if (!visible) {
            return;
        }

        newMessageLabel.textContent =
            pendingNewMessageCount === 1
                ? '1 new message'
                : `${pendingNewMessageCount} new messages`;
    };

    const clearNewMessageNotice = () => {
        pendingNewMessageCount = 0;

        newMessageBar?.classList.add(
            'hidden'
        );

        if (newMessageLabel) {
            newMessageLabel.textContent =
                'New messages';
        }
    };

    const jumpToLatest = () => {
        scrollToBottom();
        clearNewMessageNotice();
    };

    const showDrawer = () => {
        drawer.classList.remove(
            'hidden'
        );

        drawer.classList.add(
            'flex',
            'flex-col'
        );

        drawer.setAttribute(
            'aria-hidden',
            'false'
        );

        backdrop?.classList.remove(
            'hidden'
        );
    };

    const updateMuteButtonUi = () => {
        if (!muteButton) {
            return;
        }

        const isConversationMode =
            activeMode === 'conversation'
            && activeConversation;

        muteButton.classList.toggle(
            'hidden',
            !isConversationMode
        );

        if (!isConversationMode) {
            return;
        }

        const isMuted =
            Boolean(
                activeConversation
                    .isMuted
            );

        muteButton.textContent =
            isMuted
                ? '🔕'
                : '🔔';

        const label =
            isMuted
                ? 'Unmute conversation notifications'
                : 'Mute conversation notifications';

        muteButton.setAttribute(
            'aria-label',
            label
        );

        muteButton.title =
            label;

        muteButton.classList.toggle(
            'border-amber-300',
            isMuted
        );

        muteButton.classList.toggle(
            'bg-amber-50',
            isMuted
        );

        muteButton.classList.toggle(
            'text-amber-700',
            isMuted
        );

        muteButton.classList.toggle(
            'dark:border-amber-400/30',
            isMuted
        );

        muteButton.classList.toggle(
            'dark:bg-amber-400/10',
            isMuted
        );

        muteButton.classList.toggle(
            'dark:text-amber-200',
            isMuted
        );
    };

    const updateSearchButtonUi = () => {
        if (!searchToggle) {
            return;
        }

        const visible =
            (
                activeMode === 'conversation'
                || activeMode === 'search-context'
            )
            && activeConversation;

        searchToggle.classList.toggle(
            'hidden',
            !visible
        );
    };

    const closeSearch = async ({
        restoreLatest = false,
    } = {}) => {
        searchOpen = false;

        searchPanel?.classList.add(
            'hidden'
        );

        if (searchInput) {
            searchInput.value = '';
        }

        if (searchResults) {
            searchResults.replaceChildren();
            searchResults.classList.add(
                'hidden'
            );
        }

        if (
            restoreLatest
            && activeConversation
        ) {
            activeMode = 'conversation';

            form?.classList.toggle(
                'hidden',
                !activeConversation.canSend
            );

            readonlyNotice?.classList.toggle(
                'hidden',
                Boolean(
                    activeConversation.canSend
                )
            );

            await loadConversation({
                forceBottom: true,
            });

            startPolling();
            startTypingPolling();
        }
    };

    const openSearch = () => {
        if (
            !activeConversation
                ?.searchUrl
            || !activeConversation
                ?.contextUrlTemplate
        ) {
            return;
        }

        searchOpen = true;

        searchPanel?.classList.remove(
            'hidden'
        );

        searchInput?.focus();
    };

    const formatPresenceLocation = (
        value
    ) => {
        if (!value) {
            return null;
        }

        return String(value)
            .replaceAll('_', ' ')
            .replace(
                /\b\w/g,
                (character) =>
                    character.toUpperCase()
            );
    };

    const presenceText = (
        memberPresence
    ) => {
        if (!memberPresence) {
            return null;
        }

        const location =
            memberPresence.current_zone
                ? `In ${memberPresence.current_zone}`
                : memberPresence.nearest_landmark
                    ? `Near ${memberPresence.nearest_landmark}`
                    : formatPresenceLocation(
                        memberPresence.current_location
                    );

        return [
            '📍 On Live Map',
            location,
        ]
            .filter(Boolean)
            .join(' · ');
    };

    const updateMemberPresenceUi = (
        conversation = null
    ) => {
        if (!presence) {
            return;
        }

        const memberId =
            conversation
                ?.other_member
                ?.id;

        const memberPresence =
            memberId !== undefined
                && memberId !== null
                ? visibleMemberPresence
                    .get(
                        String(memberId)
                    )
                : null;

        if (!memberPresence) {
            presence.textContent = '';
            presence.classList.add(
                'hidden'
            );
            presence.removeAttribute(
                'title'
            );

            return;
        }

        presence.textContent =
            presenceText(
                memberPresence
            )
            || '📍 On Live Map';

        if (memberPresence.updated_human) {
            presence.title =
                `Location updated ${memberPresence.updated_human}`;
        } else {
            presence.removeAttribute(
                'title'
            );
        }

        presence.classList.remove(
            'hidden'
        );
    };

    const updateFindMemberButtonUi = (
        conversation = null
    ) => {
        if (!findMemberButton) {
            return;
        }

        const member =
            conversation
                ?.other_member
            || null;

        const memberId =
            member?.id
                !== undefined
                && member?.id !== null
                ? String(member.id)
                : null;

        const visible =
            Boolean(
                memberId
                && visibleMemberMarkerIds
                    .has(memberId)
            );

        findMemberButton
            .classList
            .toggle(
                'hidden',
                !visible
            );

        if (!visible) {
            findMemberButton
                .removeAttribute(
                    'data-member-id'
                );

            return;
        }

        findMemberButton.dataset.memberId =
            memberId;

        const label =
            `Find ${
                member?.name
                || 'member'
            } on map`;

        findMemberButton.setAttribute(
            'aria-label',
            label
        );

        findMemberButton.title =
            label;
    };

    const updateNavigateMemberButtonUi = (
        conversation = null
    ) => {
        if (!navigateMemberButton) {
            return;
        }

        const member =
            conversation
                ?.other_member
            || null;

        const memberId =
            member?.id
                !== undefined
                && member?.id !== null
                ? String(member.id)
                : null;

        const visible =
            Boolean(
                memberId
                && navigableMemberMarkerIds
                    .has(memberId)
            );

        navigateMemberButton
            .classList
            .toggle(
                'hidden',
                !visible
            );

        if (!visible) {
            navigateMemberButton
                .removeAttribute(
                    'data-member-id'
                );

            return;
        }

        navigateMemberButton.dataset.memberId =
            memberId;

        const label =
            `Navigate to ${
                member?.name
                || 'member'
            }`;

        navigateMemberButton.setAttribute(
            'aria-label',
            label
        );

        navigateMemberButton.title =
            `${label} with live GPS guidance`;
    };

    const updateProfileLinkUi = (
        conversation = null
    ) => {
        if (!profileLink) {
            return;
        }

        const profileUrl =
            conversation
                ?.other_member
                ?.profile_url
            || null;

        profileLink.classList.toggle(
            'hidden',
            !profileUrl
        );

        if (!profileUrl) {
            profileLink.removeAttribute(
                'href'
            );

            return;
        }

        profileLink.href =
            profileUrl;

        const memberName =
            conversation
                ?.other_member
                ?.name
            || 'member';

        const label =
            `View ${memberName}'s profile`;

        profileLink.setAttribute(
            'aria-label',
            label
        );

        profileLink.title =
            `${label} (opens in a new tab)`;
    };

    const updateInboxFilterUi = () => {
        inboxFilters?.classList.toggle(
            'hidden',
            activeMode !== 'inbox'
        );

        inboxFilterButtons.forEach(
            (button) => {
                const filter =
                    button.dataset
                        .liveMapMessageInboxFilter
                    || 'all';

                const active =
                    filter
                    === activeInboxFilter;

                button.setAttribute(
                    'aria-pressed',
                    active
                        ? 'true'
                        : 'false'
                );

                button.tabIndex =
                    active
                        ? 0
                        : -1;

                if (filter === 'all') {
                    button.classList.toggle(
                        'bg-cyan-600',
                        active
                    );

                    button.classList.toggle(
                        'text-white',
                        active
                    );

                    button.classList.toggle(
                        'border',
                        !active
                    );

                    button.classList.toggle(
                        'border-zinc-200',
                        !active
                    );

                    button.classList.toggle(
                        'bg-white',
                        !active
                    );

                    button.classList.toggle(
                        'text-zinc-600',
                        !active
                    );

                    button.classList.toggle(
                        'dark:border-white/10',
                        !active
                    );

                    button.classList.toggle(
                        'dark:bg-white/5',
                        !active
                    );

                    button.classList.toggle(
                        'dark:text-slate-300',
                        !active
                    );

                    return;
                }

                const palette =
                    filter === 'unread'
                        ? {
                            border:
                                'border-cyan-300',

                            background:
                                'bg-cyan-50',

                            text:
                                'text-cyan-700',

                            darkBorder:
                                'dark:border-cyan-400/30',

                            darkBackground:
                                'dark:bg-cyan-400/10',

                            darkText:
                                'dark:text-cyan-300',
                        }
                        : filter === 'unread-on-map'
                            ? {
                                border:
                                    'border-fuchsia-300',

                                background:
                                    'bg-fuchsia-50',

                                text:
                                    'text-fuchsia-700',

                                darkBorder:
                                    'dark:border-fuchsia-400/30',

                                darkBackground:
                                    'dark:bg-fuchsia-400/10',

                                darkText:
                                    'dark:text-fuchsia-300',
                            }
                            : {
                                border:
                                    'border-emerald-300',

                                background:
                                    'bg-emerald-50',

                                text:
                                    'text-emerald-700',

                                darkBorder:
                                    'dark:border-emerald-400/30',

                                darkBackground:
                                    'dark:bg-emerald-400/10',

                                darkText:
                                    'dark:text-emerald-300',
                            };

                button.classList.toggle(
                    palette.border,
                    active
                );

                button.classList.toggle(
                    palette.background,
                    active
                );

                button.classList.toggle(
                    palette.text,
                    active
                );

                button.classList.toggle(
                    palette.darkBorder,
                    active
                );

                button.classList.toggle(
                    palette.darkBackground,
                    active
                );

                button.classList.toggle(
                    palette.darkText,
                    active
                );
            }
        );

        if (
            activeMode !== 'inbox'
            || !inboxFilterStrip
        ) {
            return;
        }

        const activeButton =
            Array.from(
                inboxFilterButtons
            ).find(
                (button) =>
                    button.dataset
                        .liveMapMessageInboxFilter
                    === activeInboxFilter
            );

        if (!activeButton) {
            return;
        }

        window.requestAnimationFrame(
            () => {
                activeButton.scrollIntoView({
                    behavior:
                        'smooth',

                    block:
                        'nearest',

                    inline:
                        'nearest',
                });
            }
        );
    };

    const conversationIsUnread = (
        conversation
    ) => {
        return (
            Number.parseInt(
                String(
                    conversation
                        ?.unread_messages_count
                    ?? 0
                ),
                10
            ) || 0
        ) > 0;
    };

    const updateUnreadFilterCount = (
        conversations = []
    ) => {
        if (!unreadFilterCount) {
            return;
        }

        const count =
            conversations.filter(
                conversationIsUnread
            ).length;

        unreadFilterCount.textContent =
            String(count);

        unreadFilterCount.classList.toggle(
            'hidden',
            count === 0
        );
    };

    const conversationIsOnMap = (
        conversation
    ) => {
        const memberId =
            conversation
                ?.other_member
                ?.id;

        return memberId !== undefined
            && memberId !== null
            && visibleMemberPresence
                .has(
                    String(memberId)
                );
    };

    const updateOnMapCount = (
        conversations = []
    ) => {
        if (!onMapCount) {
            return;
        }

        const count =
            conversations.filter(
                conversationIsOnMap
            ).length;

        onMapCount.textContent =
            String(count);

        onMapCount.classList.toggle(
            'hidden',
            count === 0
        );
    };

    const conversationIsUnreadOnMap = (
        conversation
    ) => {
        return conversationIsUnread(
            conversation
        )
        && conversationIsOnMap(
            conversation
        );
    };

    const updateUnreadOnMapCount = (
        conversations = []
    ) => {
        if (!unreadOnMapCount) {
            return;
        }

        const count =
            conversations.filter(
                conversationIsUnreadOnMap
            ).length;

        unreadOnMapCount.textContent =
            String(count);

        unreadOnMapCount.classList.toggle(
            'hidden',
            count === 0
        );
    };

    const renderInboxHeader = () => {
        if (title) {
            title.textContent = 'Messages';
        }

        if (subtitle) {
            subtitle.textContent =
                'Recent conversations · stay on the Live Map';
        }

        if (avatar) {
            avatar.innerHTML = '';
            avatar.textContent = '💬';
        }

        backButton?.classList.add(
            'hidden'
        );

        updateMuteButtonUi();
        updateSearchButtonUi();
        updateInboxFilterUi();
        updateFindMemberButtonUi();
        updateNavigateMemberButtonUi();
        updateMemberPresenceUi();
        updateProfileLinkUi();
        clearNewMessageNotice();
        closeSearch();

        form?.classList.add(
            'hidden'
        );

        readonlyNotice?.classList.add(
            'hidden'
        );
    };

    const updateInboxPresenceRow = (
        row
    ) => {
        if (!row) {
            return;
        }

        const presenceElement =
            row.querySelector(
                '[data-live-map-inbox-presence]'
            );

        if (!presenceElement) {
            return;
        }

        const memberId =
            row.dataset
                .compactConversationMemberId;

        const memberPresence =
            memberId
                ? visibleMemberPresence
                    .get(
                        String(memberId)
                    )
                : null;

        if (!memberPresence) {
            presenceElement
                .classList
                .add(
                    'hidden'
                );

            presenceElement.textContent =
                '';

            presenceElement
                .removeAttribute(
                    'title'
                );

            return;
        }

        const fullPresenceText =
            presenceText(
                memberPresence
            )
            || '📍 On Live Map';

        presenceElement.textContent =
            fullPresenceText
                .replace(
                    '📍 On Live Map · ',
                    '📍 '
                );

        presenceElement.title =
            memberPresence.updated_human
                ? `${fullPresenceText} · Location updated ${memberPresence.updated_human}`
                : fullPresenceText;

        presenceElement
            .classList
            .remove(
                'hidden'
            );
    };

    const refreshInboxPresenceRows = () => {
        if (
            !messageList
            || activeMode !== 'inbox'
        ) {
            return;
        }

        messageList
            .querySelectorAll(
                '[data-compact-conversation-member-id]'
            )
            .forEach(
                updateInboxPresenceRow
            );
    };

    const createConversationRow = (
        conversation
    ) => {
        const button =
            document.createElement('button');

        button.type = 'button';
        button.dataset.compactConversationId =
            String(conversation.id);

        button.className = [
            'flex',
            'w-full',
            'items-center',
            'gap-3',
            'rounded-2xl',
            'border',
            'border-zinc-200',
            'bg-white',
            'p-3',
            'text-left',
            'shadow-sm',
            'transition',
            'hover:border-cyan-300',
            'hover:bg-cyan-50/60',
            'dark:border-white/10',
            'dark:bg-white/5',
            'dark:hover:border-cyan-400/30',
            'dark:hover:bg-cyan-400/10',
        ].join(' ');

        const isLastOpenedConversation =
            lastOpenedConversationId !== null
            && Number(conversation.id)
                === Number(
                    lastOpenedConversationId
                );

        if (isLastOpenedConversation) {
            button.classList.add(
                'border-cyan-400',
                'bg-cyan-50/80',
                'ring-1',
                'ring-cyan-200',
                'dark:border-cyan-400/40',
                'dark:bg-cyan-400/10',
                'dark:ring-cyan-400/20'
            );

            button.setAttribute(
                'aria-current',
                'true'
            );
        }

        const member =
            conversation.other_member;

        if (
            member?.id
            !== undefined
            && member?.id !== null
        ) {
            button.dataset
                .compactConversationMemberId =
                String(member.id);
        }

        const avatarElement =
            document.createElement('div');

        avatarElement.className =
            'flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-cyan-500 to-fuchsia-500 text-xs font-black text-white';

        if (member?.profile_photo_url) {
            const image =
                document.createElement('img');

            image.src =
                member.profile_photo_url;

            image.alt = '';
            image.className =
                'h-full w-full object-cover';

            avatarElement.appendChild(
                image
            );
        } else {
            avatarElement.textContent =
                member?.initials
                || (conversation.type === 'meetup'
                    ? '⭐'
                    : '💬');
        }

        const content =
            document.createElement('div');

        content.className =
            'min-w-0 flex-1';

        const headingRow =
            document.createElement('div');

        headingRow.className =
            'flex items-center gap-2';

        const name =
            document.createElement('div');

        name.className =
            'min-w-0 flex-1 truncate text-sm font-black text-zinc-950 dark:text-white';

        name.textContent =
            conversation.title
            || 'Conversation';

        headingRow.appendChild(name);

        const unreadCount =
            Number.parseInt(
                String(
                    conversation
                        .unread_messages_count
                    ?? 0
                ),
                10
            ) || 0;

        if (unreadCount > 0) {
            const badge =
                document.createElement('span');

            badge.className =
                'shrink-0 rounded-full bg-cyan-600 px-2 py-0.5 text-[10px] font-black text-white';

            badge.textContent =
                unreadCount > 99
                    ? '99+'
                    : String(unreadCount);

            headingRow.appendChild(badge);
        }

        const meta =
            document.createElement('div');

        meta.className =
            'mt-0.5 truncate text-[11px] font-bold text-zinc-500 dark:text-slate-400';

        meta.textContent =
            conversation.subtitle
            || conversation.type_label
            || 'Conversation';

        const statusRow =
            document.createElement(
                'div'
            );

        statusRow.className =
            'mt-1 flex min-w-0 flex-wrap items-center gap-1.5';

        const inboxPresence =
            document.createElement(
                'span'
            );

        inboxPresence.dataset
            .liveMapInboxPresence = '';

        inboxPresence.className =
            'hidden max-w-full truncate rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-black text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300';

        if (isLastOpenedConversation) {
            const activeBadge =
                document.createElement(
                    'span'
                );

            activeBadge.className =
                'shrink-0 rounded-full bg-cyan-100 px-2 py-0.5 text-[10px] font-black text-cyan-800 dark:bg-cyan-400/15 dark:text-cyan-200';

            activeBadge.textContent =
                'Active';

            activeBadge.title =
                'Last opened conversation';

            statusRow.appendChild(
                activeBadge
            );
        }

        if (conversation.is_muted) {
            const muted =
                document.createElement(
                    'span'
                );

            muted.className =
                'shrink-0 rounded-full bg-zinc-100 px-2 py-0.5 text-[10px] font-black text-zinc-600 dark:bg-white/10 dark:text-slate-300';

            muted.textContent =
                '🔕 Muted';

            muted.title =
                'Notifications muted';

            muted.setAttribute(
                'aria-label',
                'Notifications muted'
            );

            statusRow.appendChild(
                muted
            );
        }

        statusRow.appendChild(
            inboxPresence
        );

        const preview =
            document.createElement('div');

        preview.className =
            unreadCount > 0
                ? 'mt-1 truncate text-xs font-bold text-zinc-800 dark:text-slate-200'
                : 'mt-1 truncate text-xs text-zinc-600 dark:text-slate-400';

        preview.textContent =
            conversation.latest_message
                ?.preview
            || 'No messages yet';

        content.appendChild(
            headingRow
        );

        content.appendChild(meta);

        if (
            isLastOpenedConversation
            || conversation.is_muted
            || member?.id
                !== undefined
                && member?.id !== null
        ) {
            content.appendChild(
                statusRow
            );
        }

        content.appendChild(preview);

        updateInboxPresenceRow(
            button
        );

        if (
            conversation.latest_message
                ?.created_at_human
        ) {
            const time =
                document.createElement('div');

            time.className =
                'mt-1 text-[10px] text-zinc-400 dark:text-slate-500';

            time.textContent =
                conversation.latest_message
                    .created_at_human;

            content.appendChild(time);
        }

        button.appendChild(
            avatarElement
        );

        button.appendChild(content);

        button.addEventListener(
            'click',
            () => {
                openConversation({
                    conversation_id:
                        conversation.id,

                    conversation_url:
                        conversation
                            .conversation_url,

                    compact_url:
                        conversation
                            .compact_url,

                    send_url:
                        conversation.send_url,
                });
            }
        );

        return button;
    };

    const renderInbox = (payload) => {
        if (!messageList) {
            return;
        }

        const scrollTopBeforeRender =
            messageList.scrollTop;

        const targetScrollTop =
            restoreInboxScrollOnRender
                ? inboxScrollTop
                : (
                    activeMode === 'inbox'
                        ? scrollTopBeforeRender
                        : 0
                );

        latestInboxPayload =
            payload;

        messageList.innerHTML = '';

        const conversations =
            Array.isArray(
                payload.conversations
            )
                ? payload.conversations
                : [];

        updateUnreadFilterCount(
            conversations
        );

        updateOnMapCount(
            conversations
        );

        updateUnreadOnMapCount(
            conversations
        );

        const visibleConversations =
            activeInboxFilter === 'on-map'
                ? conversations.filter(
                    conversationIsOnMap
                )
                : activeInboxFilter
                    === 'unread'
                    ? conversations.filter(
                        conversationIsUnread
                    )
                    : activeInboxFilter
                        === 'unread-on-map'
                        ? conversations.filter(
                            conversationIsUnreadOnMap
                        )
                        : conversations;

        if (
            visibleConversations.length
            === 0
        ) {
            const empty =
                document.createElement('div');

            empty.className =
                'flex flex-1 flex-col items-center justify-center px-6 text-center';

            const icon =
                document.createElement('div');

            icon.className =
                'text-3xl';

            icon.textContent = '💬';

            const heading =
                document.createElement('p');

            heading.className =
                'mt-3 font-black text-zinc-900 dark:text-white';

            heading.textContent =
                activeInboxFilter
                === 'on-map'
                    ? 'No conversations are on the Live Map'
                    : activeInboxFilter
                        === 'unread'
                        ? 'You’re all caught up'
                        : activeInboxFilter
                            === 'unread-on-map'
                            ? 'No unread Live Map conversations'
                            : 'No active conversations yet';

            const helper =
                document.createElement('p');

            helper.className =
                'mt-1 text-sm text-zinc-500 dark:text-slate-400';

            helper.textContent =
                activeInboxFilter
                === 'on-map'
                    ? 'Friends will appear here when they are currently visible on your Live Map.'
                    : activeInboxFilter
                        === 'unread'
                        ? 'New conversations will appear here as unread messages arrive.'
                        : activeInboxFilter
                            === 'unread-on-map'
                            ? 'This view shows unread chats only when that member is currently visible on your Live Map.'
                            : 'Use Quick Hello on a friend’s map pin to start chatting.';

            empty.appendChild(icon);
            empty.appendChild(heading);
            empty.appendChild(helper);
            messageList.appendChild(empty);
        } else {
            visibleConversations.forEach(
                (conversation) => {
                    messageList.appendChild(
                        createConversationRow(
                            conversation
                        )
                    );
                }
            );
        }

        if (payload.messages_url) {
            const fullMessages =
                document.createElement('a');

            fullMessages.href =
                payload.messages_url;

            fullMessages.className =
                'mt-1 inline-flex items-center justify-center rounded-xl border border-zinc-200 bg-white px-3 py-2 text-xs font-black text-cyan-700 transition hover:bg-zinc-50 dark:border-white/10 dark:bg-white/5 dark:text-cyan-300 dark:hover:bg-white/10';

            fullMessages.textContent =
                'Open Full Messages';

            messageList.appendChild(
                fullMessages
            );
        }

        window.requestAnimationFrame(
            () => {
                if (
                    !messageList
                    || activeMode !== 'inbox'
                ) {
                    return;
                }

                messageList.scrollTop =
                    Math.max(
                        0,
                        targetScrollTop
                    );

                inboxScrollTop =
                    messageList.scrollTop;

                restoreInboxScrollOnRender =
                    false;
            }
        );
    };

    const loadInbox = async () => {
        if (
            !inboxUrl
            || loadingInbox
            || document.visibilityState
                === 'hidden'
        ) {
            return;
        }

        loadingInbox = true;
        setError('');

        try {
            const response = await fetch(
                inboxUrl,
                {
                    credentials:
                        'same-origin',

                    headers: {
                        Accept:
                            'application/json',

                        'X-Requested-With':
                            'XMLHttpRequest',
                    },

                    cache: 'no-store',
                }
            );

            const payload =
                await response.json()
                    .catch(
                        () => ({})
                    );

            if (!response.ok) {
                throw new Error(
                    payload?.message
                    || 'Unable to load your messages.'
                );
            }

            renderInbox(payload);
        } catch (requestError) {
            setError(
                requestError
                    instanceof Error
                    ? requestError.message
                    : 'Unable to load your messages.'
            );
        } finally {
            loadingInbox = false;
        }
    };

    const renderAvatar = (
        conversation
    ) => {
        if (!avatar) {
            return;
        }

        const member =
            conversation.other_member;

        avatar.innerHTML = '';

        if (member?.profile_photo_url) {
            const image =
                document.createElement('img');

            image.src =
                member.profile_photo_url;

            image.alt = '';

            image.className =
                'h-full w-full object-cover';

            avatar.appendChild(image);

            return;
        }

        avatar.textContent =
            member?.initials
            || '💬';
    };

    const updateCompactReactionUi = (
        row,
        state
    ) => {
        if (!row || !state) {
            return;
        }

        const counts =
            state.reaction_counts
            || {};

        const selected =
            state.selected_reaction
            || null;

        row
            .querySelectorAll(
                '[data-compact-reaction]'
            )
            .forEach((button) => {
                const reaction =
                    button.dataset
                        .compactReaction;

                const count =
                    Number.parseInt(
                        String(
                            counts[reaction]
                            ?? 0
                        ),
                        10
                    ) || 0;

                const countElement =
                    button.querySelector(
                        '[data-compact-reaction-count]'
                    );

                if (countElement) {
                    countElement.textContent =
                        count > 0
                            ? String(count)
                            : '';
                }

                const isSelected =
                    reaction === selected;

                button.setAttribute(
                    'aria-pressed',
                    isSelected
                        ? 'true'
                        : 'false'
                );

                button.classList.toggle(
                    'border-cyan-400',
                    isSelected
                );

                button.classList.toggle(
                    'bg-cyan-100',
                    isSelected
                );

                button.classList.toggle(
                    'text-cyan-800',
                    isSelected
                );

                button.classList.toggle(
                    'dark:border-cyan-400/40',
                    isSelected
                );

                button.classList.toggle(
                    'dark:bg-cyan-400/15',
                    isSelected
                );

                button.classList.toggle(
                    'dark:text-cyan-200',
                    isSelected
                );
            });
    };

    const updateReactionStates = (
        states
    ) => {
        if (
            !messageList
            || !states
            || typeof states
                !== 'object'
        ) {
            return;
        }

        Object.entries(
            states
        ).forEach(
            ([messageId, state]) => {
                const row =
                    messageList.querySelector(
                        `[data-compact-message-id="${messageId}"]`
                    );

                updateCompactReactionUi(
                    row,
                    state
                );
            }
        );
    };

    const toggleCompactReaction =
        async (
            row,
            reaction
        ) => {
            if (
                !row
                || !reaction
                || !activeConversation
                    ?.reactionUrlTemplate
            ) {
                return;
            }

            const messageId =
                row.dataset
                    .compactMessageId;

            if (!messageId) {
                return;
            }

            const url =
                activeConversation
                    .reactionUrlTemplate
                    .replace(
                        '__MESSAGE__',
                        encodeURIComponent(
                            messageId
                        )
                    );

            const csrfToken =
                document.querySelector(
                    'meta[name="csrf-token"]'
                )?.content;

            try {
                const response =
                    await fetch(
                        url,
                        {
                            method: 'POST',

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'Content-Type':
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',

                                ...(csrfToken
                                    ? {
                                        'X-CSRF-TOKEN':
                                            csrfToken,
                                    }
                                    : {}),
                            },

                            body:
                                JSON.stringify({
                                    reaction,
                                }),
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        payload?.message
                        || 'Unable to react to this message.'
                    );
                }

                updateCompactReactionUi(
                    row,
                    payload
                );
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to react to this message.'
                );
            }
        };

    const createReactionControls = (
        message
    ) => {
        if (
            message.is_deleted
            || !message
                .reaction_definitions
        ) {
            return null;
        }

        const container =
            document.createElement('div');

        container.className =
            'mt-2 flex flex-wrap gap-1';

        Object.entries(
            message.reaction_definitions
        ).forEach(
            ([reaction, definition]) => {
                const button =
                    document.createElement(
                        'button'
                    );

                button.type = 'button';

                button.dataset
                    .compactReaction =
                    reaction;

                button.className =
                    'inline-flex items-center gap-1 rounded-full border border-zinc-200 bg-white/70 px-2 py-1 text-[11px] font-bold text-zinc-600 transition hover:border-cyan-300 hover:bg-cyan-50 dark:border-white/10 dark:bg-black/10 dark:text-slate-300 dark:hover:border-cyan-400/30 dark:hover:bg-cyan-400/10';

                button.setAttribute(
                    'aria-label',
                    definition.label
                    || reaction
                );

                button.setAttribute(
                    'aria-pressed',
                    'false'
                );

                const emoji =
                    document.createElement(
                        'span'
                    );

                emoji.setAttribute(
                    'aria-hidden',
                    'true'
                );

                emoji.textContent =
                    definition.emoji
                    || '';

                const count =
                    document.createElement(
                        'span'
                    );

                count.dataset
                    .compactReactionCount = '';

                const reactionCount =
                    Number.parseInt(
                        String(
                            message
                                .reaction_counts
                                ?.[reaction]
                            ?? 0
                        ),
                        10
                    ) || 0;

                count.textContent =
                    reactionCount > 0
                        ? String(
                            reactionCount
                        )
                        : '';

                button.appendChild(
                    emoji
                );

                button.appendChild(
                    count
                );

                button.addEventListener(
                    'click',
                    () => {
                        toggleCompactReaction(
                            button.closest(
                                '[data-compact-message-id]'
                            ),
                            reaction
                        );
                    }
                );

                container.appendChild(
                    button
                );
            }
        );

        return container;
    };

    const clearReplyTarget = () => {
        if (replyIdInput) {
            replyIdInput.value = '';
        }

        if (replyLabel) {
            replyLabel.textContent =
                'Replying to';
        }

        if (replyText) {
            replyText.textContent = '';
        }

        replyPreview?.classList.add(
            'hidden'
        );
    };

    const setReplyTarget = (
        message
    ) => {
        if (
            !message
            || message.is_deleted
            || !replyIdInput
        ) {
            return;
        }

        replyIdInput.value =
            String(message.id);

        if (replyLabel) {
            replyLabel.textContent =
                `Replying to ${
                    message.is_current_user
                        ? 'yourself'
                        : (
                            message.sender_name
                            || 'Member'
                        )
                }`;
        }

        if (replyText) {
            const body =
                String(
                    message.body
                    || ''
                ).trim();

            replyText.textContent =
                body !== ''
                    ? body
                    : 'Attachment';
        }

        replyPreview?.classList.remove(
            'hidden'
        );

        input?.focus();
    };

    const messageStateSignature = (
        message
    ) => JSON.stringify({
        body:
            message?.body
            ?? '',

        is_deleted:
            Boolean(
                message?.is_deleted
            ),

        is_edited:
            Boolean(
                message?.is_edited
            ),

        reply_to:
            message?.reply_to
            ?? null,
    });

    const replaceCompactMessage = (
        message
    ) => {
        if (!messageList || !message?.id) {
            return;
        }

        const existing =
            messageList.querySelector(
                `[data-compact-message-id="${message.id}"]`
            );

        if (!existing) {
            return;
        }

        existing.replaceWith(
            createMessageBubble(
                message
            )
        );

        updateReadReceiptUi();
    };

    const updateMessageStates = (
        states
    ) => {
        if (
            !messageList
            || !states
            || typeof states
                !== 'object'
        ) {
            return;
        }

        Object.values(states)
            .forEach((message) => {
                const row =
                    messageList.querySelector(
                        `[data-compact-message-id="${message.id}"]`
                    );

                if (!row) {
                    return;
                }

                const nextSignature =
                    messageStateSignature(
                        message
                    );

                if (
                    row.dataset
                        .compactMessageState
                    === nextSignature
                ) {
                    return;
                }

                replaceCompactMessage(
                    message
                );
            });
    };

    const editCompactMessage = (
        row,
        message
    ) => {
        if (
            !row
            || !message?.is_current_user
            || message.is_deleted
            || !activeConversation
                ?.editUrlTemplate
        ) {
            return;
        }

        if (
            row.querySelector(
                '[data-compact-message-editor]'
            )
        ) {
            return;
        }

        const body =
            row.querySelector(
                '[data-compact-message-body]'
            );

        if (!body) {
            return;
        }

        body.classList.add(
            'hidden'
        );

        const editor =
            document.createElement('div');

        editor.dataset
            .compactMessageEditor = '';

        editor.className =
            'mt-1 space-y-2';

        const textarea =
            document.createElement(
                'textarea'
            );

        textarea.rows = 3;
        textarea.maxLength = 5000;

        textarea.className =
            'w-full rounded-xl border border-zinc-300 bg-white px-3 py-2 text-sm text-zinc-900 focus:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/20 dark:border-white/10 dark:bg-slate-900 dark:text-white';

        textarea.value =
            message.body
            || '';

        const actions =
            document.createElement('div');

        actions.className =
            'flex justify-end gap-2';

        const cancel =
            document.createElement(
                'button'
            );

        cancel.type = 'button';
        cancel.className =
            'rounded-lg border border-zinc-300 px-2.5 py-1.5 text-[11px] font-black dark:border-white/10';

        cancel.textContent =
            'Cancel';

        const save =
            document.createElement(
                'button'
            );

        save.type = 'button';
        save.className =
            'rounded-lg bg-cyan-600 px-2.5 py-1.5 text-[11px] font-black text-white';

        save.textContent =
            'Save';

        cancel.addEventListener(
            'click',
            () => {
                editor.remove();
                body.classList.remove(
                    'hidden'
                );
            }
        );

        save.addEventListener(
            'click',
            async () => {
                const updatedBody =
                    textarea.value.trim();

                if (!updatedBody) {
                    setError(
                        'A message cannot be empty.'
                    );

                    return;
                }

                save.disabled = true;
                cancel.disabled = true;
                save.textContent =
                    'Saving…';

                const url =
                    activeConversation
                        .editUrlTemplate
                        .replace(
                            '__MESSAGE__',
                            encodeURIComponent(
                                String(
                                    message.id
                                )
                            )
                        );

                const csrfToken =
                    document.querySelector(
                        'meta[name="csrf-token"]'
                    )?.content;

                try {
                    const response =
                        await fetch(
                            url,
                            {
                                method:
                                    'PATCH',

                                credentials:
                                    'same-origin',

                                headers: {
                                    Accept:
                                        'application/json',

                                    'Content-Type':
                                        'application/json',

                                    'X-Requested-With':
                                        'XMLHttpRequest',

                                    ...(csrfToken
                                        ? {
                                            'X-CSRF-TOKEN':
                                                csrfToken,
                                        }
                                        : {}),
                                },

                                body:
                                    JSON.stringify({
                                        body:
                                            updatedBody,
                                    }),
                            }
                        );

                    const payload =
                        await response.json()
                            .catch(
                                () => ({})
                            );

                    if (!response.ok) {
                        const validationError =
                            payload?.errors
                                ? Object
                                    .values(
                                        payload.errors
                                    )
                                    .flat()
                                    .find(
                                        (item) =>
                                            typeof item
                                            === 'string'
                                    )
                                : null;

                        throw new Error(
                            validationError
                            || payload?.message
                            || 'Unable to edit this message.'
                        );
                    }

                    if (
                        payload
                            .compact_message
                    ) {
                        replaceCompactMessage(
                            payload
                                .compact_message
                        );
                    }
                } catch (requestError) {
                    setError(
                        requestError
                            instanceof Error
                            ? requestError.message
                            : 'Unable to edit this message.'
                    );

                    save.disabled =
                        false;

                    cancel.disabled =
                        false;

                    save.textContent =
                        'Save';
                }
            }
        );

        actions.append(
            cancel,
            save
        );

        editor.append(
            textarea,
            actions
        );

        body.insertAdjacentElement(
            'afterend',
            editor
        );

        textarea.focus();
        textarea.setSelectionRange(
            textarea.value.length,
            textarea.value.length
        );
    };

    const deleteCompactMessage =
        async (
            row,
            message
        ) => {
            if (
                !row
                || !message?.is_current_user
                || message.is_deleted
                || !activeConversation
                    ?.deleteUrlTemplate
            ) {
                return;
            }

            if (
                !window.confirm(
                    'Delete this message?'
                )
            ) {
                return;
            }

            const url =
                activeConversation
                    .deleteUrlTemplate
                    .replace(
                        '__MESSAGE__',
                        encodeURIComponent(
                            String(message.id)
                        )
                    );

            const csrfToken =
                document.querySelector(
                    'meta[name="csrf-token"]'
                )?.content;

            try {
                const response =
                    await fetch(
                        url,
                        {
                            method: 'DELETE',

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',

                                ...(csrfToken
                                    ? {
                                        'X-CSRF-TOKEN':
                                            csrfToken,
                                    }
                                    : {}),
                            },
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        payload?.message
                        || 'Unable to delete this message.'
                    );
                }

                if (
                    payload
                        .compact_message
                ) {
                    replaceCompactMessage(
                        payload
                            .compact_message
                    );
                }
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to delete this message.'
                );
            }
        };

    const createMessageBubble = (
        message
    ) => {
        const row =
            document.createElement('div');

        row.dataset.compactMessageId =
            String(message.id);

        row.dataset.compactMessageOwn =
            message.is_current_user
                ? 'true'
                : 'false';

        row.dataset.compactMessageState =
            messageStateSignature(
                message
            );

        row.className =
            message.is_current_user
                ? 'flex justify-end'
                : 'flex justify-start';

        const bubble =
            document.createElement('div');

        bubble.className = [
            'max-w-[86%]',
            'rounded-2xl',
            'border',
            'px-3',
            'py-2.5',
            'text-sm',
            'shadow-sm',
            message.is_current_user
                ? 'border-fuchsia-200 bg-fuchsia-50 text-zinc-900 dark:border-fuchsia-400/30 dark:bg-fuchsia-600 dark:text-white'
                : 'border-zinc-200 bg-white text-zinc-800 dark:border-white/10 dark:bg-white/5 dark:text-slate-200',
        ].join(' ');

        if (!message.is_current_user) {
            const sender =
                document.createElement('div');

            sender.className =
                'mb-1 text-[11px] font-black text-cyan-700 dark:text-cyan-300';

            sender.textContent =
                message.sender_name
                || 'Member';

            bubble.appendChild(sender);
        }

        if (message.reply_to) {
            const replyContext =
                document.createElement('button');

            replyContext.type =
                'button';

            replyContext.className =
                'mb-2 block w-full rounded-xl border border-current/10 bg-black/5 px-2.5 py-2 text-left transition hover:bg-black/10 dark:bg-white/5 dark:hover:bg-white/10';

            const replyContextLabel =
                document.createElement('div');

            replyContextLabel.className =
                'text-[10px] font-black uppercase tracking-wide opacity-70';

            replyContextLabel.textContent =
                `Reply to ${
                    message.reply_to.sender_name
                    || 'Member'
                }`;

            const replyContextBody =
                document.createElement('div');

            replyContextBody.className =
                'mt-0.5 line-clamp-2 text-xs opacity-80';

            replyContextBody.textContent =
                message.reply_to.body
                || 'Message';

            replyContext.appendChild(
                replyContextLabel
            );

            replyContext.appendChild(
                replyContextBody
            );

            replyContext.addEventListener(
                'click',
                () => {
                    const target =
                        messageList
                            ?.querySelector(
                                `[data-compact-message-id="${message.reply_to.id}"]`
                            );

                    target?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            );

            bubble.appendChild(
                replyContext
            );
        }

        const body =
            document.createElement('div');

        body.dataset
            .compactMessageBody = '';

        body.className =
            'whitespace-pre-wrap break-words leading-5';

        if (message.is_deleted) {
            body.classList.add(
                'italic',
                'opacity-70'
            );
        }

        body.textContent =
            message.body
            || '';

        bubble.appendChild(body);

        if (
            message.is_edited
            && !message.is_deleted
        ) {
            const edited =
                document.createElement(
                    'div'
                );

            edited.className =
                'mt-1 text-[10px] italic opacity-55';

            edited.textContent =
                'Edited';

            bubble.appendChild(
                edited
            );
        }

        if (
            Array.isArray(message.attachments)
            && message.attachments.length
        ) {
            const attachments =
                document.createElement('div');

            attachments.className =
                'mt-2 space-y-1';

            message.attachments.forEach(
                (attachment) => {
                    const link =
                        document.createElement('a');

                    link.href =
                        attachment.url;

                    link.target = '_blank';
                    link.rel = 'noopener';

                    if (
                        attachment.is_image
                    ) {
                        link.className =
                            'block overflow-hidden rounded-xl border border-current/15';

                        const image =
                            document.createElement(
                                'img'
                            );

                        image.src =
                            attachment.url;

                        image.alt =
                            attachment.name
                            || 'Message photo';

                        image.loading =
                            'lazy';

                        image.className =
                            'max-h-48 w-full object-cover';

                        link.appendChild(
                            image
                        );
                    } else {
                        link.className =
                            'block truncate rounded-lg border border-current/15 px-2 py-1.5 text-xs font-bold underline-offset-2 hover:underline';

                        link.textContent =
                            `📎 ${attachment.name}`;
                    }

                    attachments.appendChild(
                        link
                    );
                }
            );

            bubble.appendChild(
                attachments
            );
        }

        const reactionControls =
            createReactionControls(
                message
            );

        if (reactionControls) {
            bubble.appendChild(
                reactionControls
            );
        }

        if (!message.is_deleted) {
            const messageActions =
                document.createElement(
                    'div'
                );

            messageActions.className =
                'mt-1.5 flex flex-wrap gap-2';

            const replyAction =
                document.createElement(
                    'button'
                );

            replyAction.type =
                'button';

            replyAction.className =
                'text-[10px] font-black opacity-60 transition hover:opacity-100';

            replyAction.textContent =
                'Reply';

            replyAction.addEventListener(
                'click',
                () => setReplyTarget(
                    message
                )
            );

            messageActions.appendChild(
                replyAction
            );

            if (
                message.is_current_user
                && activeConversation
                    ?.canSend
            ) {
                const editAction =
                    document.createElement(
                        'button'
                    );

                editAction.type =
                    'button';

                editAction.className =
                    'text-[10px] font-black opacity-60 transition hover:opacity-100';

                editAction.textContent =
                    'Edit';

                editAction.addEventListener(
                    'click',
                    () => editCompactMessage(
                        row,
                        message
                    )
                );

                const deleteAction =
                    document.createElement(
                        'button'
                    );

                deleteAction.type =
                    'button';

                deleteAction.className =
                    'text-[10px] font-black text-rose-600 opacity-70 transition hover:opacity-100 dark:text-rose-300';

                deleteAction.textContent =
                    'Delete';

                deleteAction.addEventListener(
                    'click',
                    () => deleteCompactMessage(
                        row,
                        message
                    )
                );

                messageActions.append(
                    editAction,
                    deleteAction
                );
            }

            bubble.appendChild(
                messageActions
            );
        }

        const time =
            document.createElement('div');

        time.className =
            'mt-1.5 text-[10px] opacity-60';

        time.textContent =
            message.created_at_time
            || message.created_at_human
            || '';

        bubble.appendChild(time);

        if (message.is_current_user) {
            const readReceipt =
                document.createElement(
                    'div'
                );

            readReceipt.dataset
                .compactMessageReadReceipt = '';

            readReceipt.className =
                'mt-1 hidden text-right text-[10px] font-black text-cyan-700 dark:text-cyan-300';

            readReceipt.textContent =
                'Read';

            bubble.appendChild(
                readReceipt
            );
        }

        row.appendChild(bubble);

        updateCompactReactionUi(
            row,
            {
                selected_reaction:
                    message.selected_reaction,

                reaction_counts:
                    message.reaction_counts,
            }
        );

        return row;
    };

    const updateReadReceiptUi = () => {
        if (!messageList) {
            return;
        }

        const ownMessageRows =
            Array.from(
                messageList.querySelectorAll(
                    '[data-compact-message-own="true"]'
                )
            );

        ownMessageRows.forEach((row) => {
            row.querySelector(
                '[data-compact-message-read-receipt]'
            )?.classList.add(
                'hidden'
            );
        });

        const latestReadOwnRow =
            ownMessageRows
                .filter((row) => {
                    const messageId =
                        Number.parseInt(
                            row.dataset
                                .compactMessageId
                                ?? '0',
                            10
                        );

                    return messageId > 0
                        && messageId
                            <= readThroughMessageId;
                })
                .sort((a, b) =>
                    Number.parseInt(
                        b.dataset
                            .compactMessageId
                            ?? '0',
                        10
                    )
                    - Number.parseInt(
                        a.dataset
                            .compactMessageId
                            ?? '0',
                        10
                    )
                )[0];

        latestReadOwnRow
            ?.querySelector(
                '[data-compact-message-read-receipt]'
            )
            ?.classList.remove(
                'hidden'
            );
    };

    const renderMessages = (
        messages,
        forceBottom = false
    ) => {
        if (!messageList) {
            return;
        }

        const shouldScroll =
            forceBottom
            || isNearBottom();

        const existingIds =
            new Set(
                Array.from(
                    messageList.querySelectorAll(
                        '[data-compact-message-id]'
                    )
                ).map(
                    (element) =>
                        Number.parseInt(
                            element.dataset
                                .compactMessageId,
                            10
                        )
                )
            );

        if (
            existingIds.size === 0
        ) {
            messageList.innerHTML = '';
        }

        let addedMessageCount = 0;

        messages.forEach((message) => {
            latestMessageId =
                Math.max(
                    latestMessageId,
                    Number(message.id) || 0
                );

            if (
                existingIds.has(
                    Number(message.id)
                )
            ) {
                return;
            }

            messageList.appendChild(
                createMessageBubble(
                    message
                )
            );

            addedMessageCount += 1;
        });

        if (
            messageList.children.length
            === 0
        ) {
            const empty =
                document.createElement('div');

            empty.className =
                'flex flex-1 items-center justify-center text-center text-sm font-semibold text-zinc-500 dark:text-slate-400';

            empty.textContent =
                'No messages yet. Say hello!';

            messageList.appendChild(
                empty
            );
        }

        updateReadReceiptUi();

        if (shouldScroll) {
            clearNewMessageNotice();

            window.requestAnimationFrame(
                scrollToBottom
            );

            return;
        }

        if (
            addedMessageCount > 0
            && activeMode
                === 'conversation'
        ) {
            pendingNewMessageCount +=
                addedMessageCount;

            updateNewMessageUi();
        }
    };

    const renderHistoryControl = () => {
        if (!messageList) {
            return;
        }

        messageList
            .querySelector(
                '[data-live-map-message-history]'
            )
            ?.remove();

        if (
            !hasOlderMessages
            || !activeConversation
                ?.historyUrl
        ) {
            return;
        }

        const wrapper =
            document.createElement('div');

        wrapper.dataset
            .liveMapMessageHistory = '';

        wrapper.className =
            'flex justify-center pb-1';

        const button =
            document.createElement('button');

        button.type = 'button';

        button.className =
            'rounded-full border border-zinc-200 bg-white px-3 py-1.5 text-[11px] font-black text-cyan-700 shadow-sm transition hover:bg-cyan-50 dark:border-white/10 dark:bg-white/5 dark:text-cyan-300 dark:hover:bg-cyan-400/10';

        button.textContent =
            'Load Earlier Messages';

        button.addEventListener(
            'click',
            () => loadEarlierMessages(
                button
            )
        );

        wrapper.appendChild(button);

        messageList.prepend(wrapper);
    };

    const prependMessages = (
        messages
    ) => {
        if (
            !messageList
            || !Array.isArray(messages)
            || messages.length === 0
        ) {
            return;
        }

        const oldScrollHeight =
            messageList.scrollHeight;

        const historyControl =
            messageList.querySelector(
                '[data-live-map-message-history]'
            );

        const anchor =
            historyControl
                ? historyControl.nextSibling
                : messageList.firstChild;

        messages.forEach((message) => {
            if (
                messageList.querySelector(
                    `[data-compact-message-id="${message.id}"]`
                )
            ) {
                return;
            }

            const element =
                createMessageBubble(
                    message
                );

            messageList.insertBefore(
                element,
                anchor
            );
        });

        const newScrollHeight =
            messageList.scrollHeight;

        messageList.scrollTop +=
            newScrollHeight
            - oldScrollHeight;

        updateReadReceiptUi();
    };

    const loadEarlierMessages =
        async (button = null) => {
            if (
                loadingHistory
                || !hasOlderMessages
                || !oldestMessageId
                || !activeConversation
                    ?.historyUrl
            ) {
                return;
            }

            loadingHistory = true;

            const originalText =
                button?.textContent;

            if (button) {
                button.disabled = true;
                button.textContent =
                    'Loading…';
            }

            try {
                const separator =
                    activeConversation
                        .historyUrl
                        .includes('?')
                        ? '&'
                        : '?';

                const response =
                    await fetch(
                        `${activeConversation.historyUrl}`
                        + `${separator}before_id=${oldestMessageId}`,
                        {
                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },

                            cache:
                                'no-store',
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        payload?.message
                        || 'Unable to load earlier messages.'
                    );
                }

                const messages =
                    Array.isArray(
                        payload.messages
                    )
                        ? payload.messages
                        : [];

                prependMessages(
                    messages
                );

                oldestMessageId =
                    Number(
                        payload.oldest_id
                        ?? oldestMessageId
                    ) || oldestMessageId;

                hasOlderMessages =
                    Boolean(
                        payload.has_older
                    );

                readThroughMessageId =
                    Number(
                        payload
                            .read_through_message_id
                        ?? readThroughMessageId
                    ) || 0;

                renderHistoryControl();
                updateReadReceiptUi();
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to load earlier messages.'
                );
            } finally {
                loadingHistory = false;

                if (
                    button
                    && button.isConnected
                ) {
                    button.disabled =
                        false;

                    button.textContent =
                        originalText
                        || 'Load Earlier Messages';
                }
            }
        };

    const applyConversation = (
        payload,
        {
            forceBottom = false,
        } = {}
    ) => {
        const conversation =
            payload.conversation;

        if (!conversation) {
            return;
        }

        if (title) {
            title.textContent =
                conversation.title
                || 'Messages';
        }

        if (subtitle) {
            subtitle.textContent =
                conversation.subtitle
                || 'Chat without leaving the Live Map';
        }

        renderAvatar(
            conversation
        );

        updateFindMemberButtonUi(
            conversation
        );

        updateNavigateMemberButtonUi(
            conversation
        );

        updateMemberPresenceUi(
            conversation
        );

        updateProfileLinkUi(
            conversation
        );

        activeMode = 'conversation';
        updateInboxFilterUi();

        backButton?.classList.remove(
            'hidden'
        );

        updateMuteButtonUi();
        updateSearchButtonUi();

        const canSend =
            Boolean(
                conversation.can_send
            );

        if (activeConversation) {
            activeConversation.canSend =
                canSend;

            activeConversation.conversation =
                conversation;
        }

        form?.classList.toggle(
            'hidden',
            !canSend
        );

        readonlyNotice
            ?.classList.toggle(
                'hidden',
                canSend
            );

        if (
            fullLink
            && payload
                .full_conversation_url
        ) {
            fullLink.href =
                payload
                    .full_conversation_url;
        }

        if (activeConversation) {
            activeConversation.sendUrl =
                payload.send_url
                || activeConversation
                    .sendUrl;

            activeConversation.updatesUrl =
                payload.updates_url
                || activeConversation
                    .updatesUrl;

            activeConversation.historyUrl =
                payload.history_url
                || activeConversation
                    .historyUrl;

            activeConversation.searchUrl =
                payload.search_url
                || activeConversation
                    .searchUrl;

            activeConversation.mentionUrl =
                payload.mention_url
                || activeConversation
                    .mentionUrl;

            if (
                input
                && activeConversation
                    .mentionUrl
            ) {
                input.dataset
                    .mentionEndpoint =
                    activeConversation
                        .mentionUrl;

                initializeMentionAutocompletes(
                    drawer
                );
            }

            activeConversation.contextUrlTemplate =
                payload.context_url_template
                || activeConversation
                    .contextUrlTemplate;

            activeConversation.reactionUrlTemplate =
                payload.reaction_url_template
                || activeConversation
                    .reactionUrlTemplate;

            activeConversation.editUrlTemplate =
                payload.edit_url_template
                || activeConversation
                    .editUrlTemplate;

            activeConversation.deleteUrlTemplate =
                payload.delete_url_template
                || activeConversation
                    .deleteUrlTemplate;

            activeConversation.muteUrl =
                payload.mute_url
                || activeConversation
                    .muteUrl;

            activeConversation.isMuted =
                Boolean(
                    conversation.is_muted
                );

            activeConversation.typingUpdateUrl =
                payload.typing_update_url
                || activeConversation
                    .typingUpdateUrl;

            activeConversation.typingStatusUrl =
                payload.typing_status_url
                || activeConversation
                    .typingStatusUrl;
        }

        oldestMessageId =
            Number(
                payload.oldest_id
                ?? 0
            ) || 0;

        hasOlderMessages =
            Boolean(
                payload.has_older
            );

        readThroughMessageId =
            Number(
                payload
                    .read_through_message_id
                ?? 0
            ) || 0;

        renderMessages(
            Array.isArray(
                payload.messages
            )
                ? payload.messages
                : [],
            forceBottom
        );

        renderHistoryControl();

        window.dispatchEvent(
            new CustomEvent(
                'festfriends:message-read-state-changed'
            )
        );
    };

    const loadConversation =
        async ({
            forceBottom = false,
        } = {}) => {
            if (
                !activeConversation
                || loadingConversation
                || document.visibilityState
                    === 'hidden'
            ) {
                return;
            }

            loadingConversation = true;

            try {
                const response =
                    await fetch(
                        activeConversation
                            .compactUrl,
                        {
                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },

                            cache: 'no-store',
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        payload?.message
                        || 'Unable to load this conversation.'
                    );
                }

                loading?.remove();

                applyConversation(
                    payload,
                    {
                        forceBottom,
                    }
                );
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to load this conversation.'
                );
            } finally {
                loadingConversation = false;
            }
        };

    const loadConversationUpdates =
        async ({
            forceBottom = false,
        } = {}) => {
            if (
                !activeConversation
                || !activeConversation.updatesUrl
                || loadingConversation
                || document.visibilityState
                    === 'hidden'
            ) {
                return;
            }

            loadingConversation = true;

            try {
                const separator =
                    activeConversation
                        .updatesUrl
                        .includes('?')
                        ? '&'
                        : '?';

                let nextUrl =
                    `${activeConversation.updatesUrl}`
                    + `${separator}after_id=${latestMessageId}`;

                let shouldForceBottom =
                    forceBottom;

                do {
                    const response =
                        await fetch(
                            nextUrl,
                            {
                                credentials:
                                    'same-origin',

                                headers: {
                                    Accept:
                                        'application/json',

                                    'X-Requested-With':
                                        'XMLHttpRequest',
                                },

                                cache:
                                    'no-store',
                            }
                        );

                    const payload =
                        await response.json()
                            .catch(
                                () => ({})
                            );

                    if (!response.ok) {
                        throw new Error(
                            payload?.message
                            || 'Unable to refresh this conversation.'
                        );
                    }

                    readThroughMessageId =
                        Number(
                            payload
                                .read_through_message_id
                            ?? readThroughMessageId
                        ) || 0;

                    updateReadReceiptUi();

                    const messages =
                        Array.isArray(
                            payload.messages
                        )
                            ? payload.messages
                            : [];

                    updateReactionStates(
                        payload
                            .reaction_states
                    );

                    updateMessageStates(
                        payload
                            .message_states
                    );

                    if (messages.length) {
                        renderMessages(
                            messages,
                            shouldForceBottom
                        );

                        latestMessageId =
                            Math.max(
                                latestMessageId,
                                Number(
                                    payload.latest_id
                                    ?? 0
                                )
                            );

                        shouldForceBottom =
                            false;

                        window.dispatchEvent(
                            new CustomEvent(
                                'festfriends:message-read-state-changed'
                            )
                        );
                    }

                    if (!payload.has_more) {
                        break;
                    }

                    nextUrl =
                        `${activeConversation.updatesUrl}`
                        + `${separator}after_id=${latestMessageId}`;
                } while (true);
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to refresh this conversation.'
                );
            } finally {
                loadingConversation = false;
            }
        };

    const renderSearchResults = (
        results
    ) => {
        if (!searchResults) {
            return;
        }

        searchResults.replaceChildren();

        if (
            !Array.isArray(results)
            || results.length === 0
        ) {
            const empty =
                document.createElement('p');

            empty.className =
                'px-2 py-3 text-center text-xs font-semibold text-zinc-500 dark:text-slate-400';

            empty.textContent =
                'No matching messages found.';

            searchResults.appendChild(
                empty
            );

            searchResults.classList.remove(
                'hidden'
            );

            return;
        }

        results.forEach((result) => {
            const button =
                document.createElement(
                    'button'
                );

            button.type = 'button';

            button.className =
                'block w-full rounded-lg px-2.5 py-2 text-left transition hover:bg-white dark:hover:bg-white/5';

            const sender =
                document.createElement(
                    'div'
                );

            sender.className =
                'text-[11px] font-black text-cyan-700 dark:text-cyan-300';

            sender.textContent =
                result.sender
                || 'Member';

            const body =
                document.createElement(
                    'div'
                );

            body.className =
                'mt-0.5 line-clamp-2 text-xs text-zinc-700 dark:text-slate-300';

            body.textContent =
                result.body
                || 'Message';

            const time =
                document.createElement(
                    'div'
                );

            time.className =
                'mt-1 text-[10px] text-zinc-400 dark:text-slate-500';

            if (result.created_at) {
                const parsed =
                    new Date(
                        result.created_at
                    );

                time.textContent =
                    Number.isNaN(
                        parsed.getTime()
                    )
                        ? ''
                        : parsed
                            .toLocaleString();
            }

            button.append(
                sender,
                body,
                time
            );

            button.addEventListener(
                'click',
                () => {
                    loadSearchContext(
                        result.id
                    );
                }
            );

            searchResults.appendChild(
                button
            );
        });

        searchResults.classList.remove(
            'hidden'
        );
    };

    const loadSearchContext =
        async (messageId) => {
            if (
                !activeConversation
                    ?.contextUrlTemplate
                || !messageId
            ) {
                return;
            }

            stopPolling();
            stopTypingPolling();
            clearNewMessageNotice();

            activeMode =
                'search-context';

            form?.classList.add(
                'hidden'
            );

            readonlyNotice?.classList.add(
                'hidden'
            );

            if (searchResults) {
                searchResults.classList.add(
                    'hidden'
                );
            }

            if (messageList) {
                messageList.innerHTML = `
                    <div class="flex flex-1 items-center justify-center text-sm font-semibold text-zinc-500 dark:text-slate-400">
                        Loading message context…
                    </div>
                `;
            }

            const url =
                activeConversation
                    .contextUrlTemplate
                    .replace(
                        '__MESSAGE__',
                        encodeURIComponent(
                            String(messageId)
                        )
                    );

            try {
                const response =
                    await fetch(
                        url,
                        {
                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },

                            cache:
                                'no-store',
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        payload?.message
                        || 'Unable to load this search result.'
                    );
                }

                if (!messageList) {
                    return;
                }

                messageList.replaceChildren();

                const contextHeader =
                    document.createElement(
                        'div'
                    );

                contextHeader.className =
                    'sticky top-0 z-10 flex items-center justify-between gap-3 rounded-xl border border-cyan-200 bg-cyan-50 px-3 py-2 text-xs font-bold text-cyan-800 shadow-sm dark:border-cyan-400/20 dark:bg-slate-900 dark:text-cyan-200';

                const contextLabel =
                    document.createElement(
                        'span'
                    );

                contextLabel.textContent =
                    'Viewing search result';

                const backToLatest =
                    document.createElement(
                        'button'
                    );

                backToLatest.type =
                    'button';

                backToLatest.className =
                    'shrink-0 rounded-lg bg-cyan-600 px-2.5 py-1.5 text-[11px] font-black text-white hover:bg-cyan-500';

                backToLatest.textContent =
                    'Back to Latest';

                backToLatest.addEventListener(
                    'click',
                    () => {
                        closeSearch({
                            restoreLatest:
                                true,
                        });
                    }
                );

                contextHeader.append(
                    contextLabel,
                    backToLatest
                );

                messageList.appendChild(
                    contextHeader
                );

                const messages =
                    Array.isArray(
                        payload.messages
                    )
                        ? payload.messages
                        : [];

                messages.forEach(
                    (message) => {
                        messageList.appendChild(
                            createMessageBubble(
                                message
                            )
                        );
                    }
                );

                readThroughMessageId =
                    Math.max(
                        0,
                        Number(
                            payload
                                .read_through_message_id
                            ?? 0
                        ) || 0
                    );

                updateReadReceiptUi();

                const target =
                    messageList.querySelector(
                        `[data-compact-message-id="${payload.target_id}"]`
                    );

                if (target) {
                    target.classList.add(
                        'ring-2',
                        'ring-cyan-400',
                        'ring-offset-2',
                        'ring-offset-zinc-50',
                        'dark:ring-offset-slate-900'
                    );

                    window.requestAnimationFrame(
                        () => target
                            .scrollIntoView({
                                behavior:
                                    'smooth',

                                block:
                                    'center',
                            })
                    );
                }
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to load this search result.'
                );
            }
        };

    const runSearch = async () => {
        const query =
            searchInput
                ?.value
                .trim()
            ?? '';

        if (
            query.length < 2
            || !activeConversation
                ?.searchUrl
            || searching
        ) {
            return;
        }

        searching = true;
        setError('');

        if (searchResults) {
            searchResults.innerHTML = `
                <p class="px-2 py-3 text-center text-xs font-semibold text-zinc-500 dark:text-slate-400">
                    Searching…
                </p>
            `;

            searchResults.classList.remove(
                'hidden'
            );
        }

        const separator =
            activeConversation
                .searchUrl
                .includes('?')
                ? '&'
                : '?';

        try {
            const response =
                await fetch(
                    `${activeConversation.searchUrl}${separator}q=${encodeURIComponent(query)}`,
                    {
                        credentials:
                            'same-origin',

                        headers: {
                            Accept:
                                'application/json',

                            'X-Requested-With':
                                'XMLHttpRequest',
                        },

                        cache:
                            'no-store',
                    }
                );

            const payload =
                await response.json()
                    .catch(
                        () => ({})
                    );

            if (!response.ok) {
                throw new Error(
                    payload?.message
                    || 'Unable to search this conversation.'
                );
            }

            renderSearchResults(
                payload.results
            );
        } catch (requestError) {
            setError(
                requestError
                    instanceof Error
                    ? requestError.message
                    : 'Unable to search this conversation.'
            );
        } finally {
            searching = false;
        }
    };

    const stopPolling = () => {
        if (pollTimer) {
            window.clearInterval(
                pollTimer
            );

            pollTimer = null;
        }
    };

    const startPolling = () => {
        stopPolling();

        pollTimer =
            window.setInterval(
                () => loadConversationUpdates(),
                2500
            );
    };

    const openInbox = async () => {
        stopPolling();
        stopTypingPolling();

        activeConversation = null;
        activeMode = 'inbox';
        latestMessageId = 0;
        oldestMessageId = 0;
        hasOlderMessages = false;

        showDrawer();
        renderInboxHeader();
        setError('');
        clearReplyTarget();

        if (messageList) {
            messageList.innerHTML = `
                <div class="flex flex-1 items-center justify-center text-sm font-semibold text-zinc-500 dark:text-slate-400">
                    Loading recent conversations…
                </div>
            `;
        }

        await loadInbox();

        pollTimer =
            window.setInterval(
                () => loadInbox(),
                10000
            );
    };

    const closeDrawer = () => {
        stopPolling();
        stopTypingPolling();

        drawer.classList.add(
            'hidden'
        );

        drawer.classList.remove(
            'flex'
        );

        drawer.setAttribute(
            'aria-hidden',
            'true'
        );

        backdrop?.classList.add(
            'hidden'
        );

        clearReplyTarget();
        closeSearch();

        activeConversation = null;
        latestInboxPayload = null;
        inboxScrollTop = 0;
        restoreInboxScrollOnRender = false;
        activeMode = 'closed';
        updateInboxFilterUi();
        latestMessageId = 0;
        oldestMessageId = 0;
        hasOlderMessages = false;
        readThroughMessageId = 0;
        clearNewMessageNotice();
        setError('');
    };

    const openConversation =
        async (detail = {}) => {
            if (
                activeMode === 'inbox'
                && messageList
            ) {
                inboxScrollTop =
                    messageList.scrollTop;

                restoreInboxScrollOnRender =
                    true;
            }

            const compactUrl =
                detail.compact_url
                || detail.compactUrl;

            if (!compactUrl) {
                if (
                    detail.conversation_url
                ) {
                    window.location.href =
                        detail
                            .conversation_url;
                }

                return;
            }

            activeConversation = {
                id:
                    Number(
                        detail
                            .conversation_id
                        ?? detail.id
                        ?? 0
                    ),

                compactUrl,

                sendUrl:
                    detail.send_url
                    || detail.sendUrl
                    || null,

                updatesUrl:
                    detail.updates_url
                    || detail.updatesUrl
                    || null,

                historyUrl:
                    detail.history_url
                    || detail.historyUrl
                    || null,

                searchUrl:
                    detail.search_url
                    || detail.searchUrl
                    || null,

                mentionUrl:
                    detail.mention_url
                    || detail.mentionUrl
                    || null,

                contextUrlTemplate:
                    detail.context_url_template
                    || detail.contextUrlTemplate
                    || null,

                reactionUrlTemplate:
                    detail.reaction_url_template
                    || detail.reactionUrlTemplate
                    || null,

                editUrlTemplate:
                    detail.edit_url_template
                    || detail.editUrlTemplate
                    || null,

                deleteUrlTemplate:
                    detail.delete_url_template
                    || detail.deleteUrlTemplate
                    || null,

                muteUrl:
                    detail.mute_url
                    || detail.muteUrl
                    || null,

                isMuted:
                    Boolean(
                        detail.is_muted
                        ?? detail.isMuted
                        ?? false
                    ),

                typingUpdateUrl:
                    detail.typing_update_url
                    || detail.typingUpdateUrl
                    || null,

                typingStatusUrl:
                    detail.typing_status_url
                    || detail.typingStatusUrl
                    || null,
            };

            if (activeConversation.id > 0) {
                lastOpenedConversationId =
                    activeConversation.id;
            }

            latestMessageId = 0;
            oldestMessageId = 0;
            hasOlderMessages = false;
            readThroughMessageId = 0;
            clearNewMessageNotice();

            if (messageList) {
                messageList.innerHTML = `
                    <div class="flex flex-1 items-center justify-center text-sm font-semibold text-zinc-500 dark:text-slate-400">
                        Loading conversation…
                    </div>
                `;
            }

            showDrawer();
            setError('');
            clearReplyTarget();
            closeSearch();

            await loadConversation({
                forceBottom: true,
            });

            startPolling();
            startTypingPolling();

            window.setTimeout(
                () => input?.focus(),
                150
            );
        };

    window.addEventListener(
        'festival:member-markers-changed',
        (event) => {
            const memberIds =
                Array.isArray(
                    event.detail
                        ?.memberIds
                )
                    ? event.detail
                        .memberIds
                    : [];

            visibleMemberMarkerIds =
                new Set(
                    memberIds.map(
                        (memberId) =>
                            String(memberId)
                    )
                );

            const navigableMemberIds =
                Array.isArray(
                    event.detail
                        ?.navigableMemberIds
                )
                    ? event.detail
                        .navigableMemberIds
                    : [];

            navigableMemberMarkerIds =
                new Set(
                    navigableMemberIds.map(
                        (memberId) =>
                            String(memberId)
                    )
                );

            const presenceMembers =
                Array.isArray(
                    event.detail
                        ?.members
                )
                    ? event.detail
                        .members
                    : [];

            visibleMemberPresence =
                new Map(
                    presenceMembers
                        .filter(
                            (member) =>
                                member?.id
                                !== undefined
                                && member?.id
                                !== null
                        )
                        .map(
                            (member) => [
                                String(member.id),
                                member,
                            ]
                        )
                );

            const conversation =
                activeMode
                    === 'conversation'
                    ? activeConversation
                        ?.conversation
                    : null;

            updateFindMemberButtonUi(
                conversation
            );

            updateNavigateMemberButtonUi(
                conversation
            );

            updateMemberPresenceUi(
                conversation
            );

            if (
                activeMode === 'inbox'
                && latestInboxPayload
                && [
                    'on-map',
                    'unread-on-map',
                ].includes(
                    activeInboxFilter
                )
            ) {
                renderInbox(
                    latestInboxPayload
                );
            } else {
                refreshInboxPresenceRows();

                const conversations =
                    Array.isArray(
                        latestInboxPayload
                            ?.conversations
                    )
                        ? latestInboxPayload
                            .conversations
                        : [];

                updateUnreadFilterCount(
                    conversations
                );

                updateOnMapCount(
                    conversations
                );

                updateUnreadOnMapCount(
                    conversations
                );
            }
        }
    );

    findMemberButton?.addEventListener(
        'click',
        () => {
            const memberId =
                findMemberButton
                    .dataset
                    .memberId;

            if (!memberId) {
                return;
            }

            const focusMember = () => {
                window.dispatchEvent(
                    new CustomEvent(
                        'festival:focus-member',
                        {
                            detail: {
                                memberId,
                            },
                        }
                    )
                );
            };

            if (
                window.matchMedia(
                    '(max-width: 639px)'
                ).matches
            ) {
                closeDrawer();

                window.setTimeout(
                    focusMember,
                    180
                );

                return;
            }

            focusMember();
        }
    );

    window.dispatchEvent(
        new CustomEvent(
            'festival:request-member-markers'
        )
    );

    navigateMemberButton?.addEventListener(
        'click',
        () => {
            const memberId =
                navigateMemberButton
                    .dataset
                    .memberId;

            const member =
                activeConversation
                    ?.conversation
                    ?.other_member;

            if (
                !memberId
                || !navigableMemberMarkerIds
                    .has(
                        String(memberId)
                    )
            ) {
                return;
            }

            const startNavigation = () => {
                window.dispatchEvent(
                    new CustomEvent(
                        'festival:navigate-member',
                        {
                            detail: {
                                memberId,

                                memberName:
                                    member?.name
                                    || 'Friend',
                            },
                        }
                    )
                );
            };

            if (
                window.matchMedia(
                    '(max-width: 639px)'
                ).matches
            ) {
                closeDrawer();

                window.setTimeout(
                    startNavigation,
                    180
                );

                return;
            }

            startNavigation();
        }
    );

    const focusInboxFilterByOffset = (
        currentButton,
        offset
    ) => {
        const buttons =
            Array.from(
                inboxFilterButtons
            );

        const currentIndex =
            buttons.indexOf(
                currentButton
            );

        if (
            currentIndex < 0
            || buttons.length === 0
        ) {
            return;
        }

        const nextIndex =
            (
                currentIndex
                + offset
                + buttons.length
            )
            % buttons.length;

        const nextButton =
            buttons[nextIndex];

        nextButton?.focus();

        nextButton?.scrollIntoView({
            behavior:
                'smooth',

            block:
                'nearest',

            inline:
                'nearest',
        });
    };

    inboxFilterStrip?.addEventListener(
        'keydown',
        (event) => {
            const currentButton =
                event.target.closest(
                    '[data-live-map-message-inbox-filter]'
                );

            if (!currentButton) {
                return;
            }

            if (
                event.key === 'ArrowRight'
                || event.key === 'ArrowDown'
            ) {
                event.preventDefault();

                focusInboxFilterByOffset(
                    currentButton,
                    1
                );

                return;
            }

            if (
                event.key === 'ArrowLeft'
                || event.key === 'ArrowUp'
            ) {
                event.preventDefault();

                focusInboxFilterByOffset(
                    currentButton,
                    -1
                );

                return;
            }

            if (
                event.key === 'Home'
                || event.key === 'End'
            ) {
                event.preventDefault();

                const buttons =
                    Array.from(
                        inboxFilterButtons
                    );

                const target =
                    event.key === 'Home'
                        ? buttons[0]
                        : buttons[
                            buttons.length - 1
                        ];

                target?.focus();

                target?.scrollIntoView({
                    behavior:
                        'smooth',

                    block:
                        'nearest',

                    inline:
                        'nearest',
                });
            }
        }
    );

    inboxFilterButtons.forEach(
        (button) => {
            button.addEventListener(
                'click',
                () => {
                    const nextFilter =
                        button.dataset
                            .liveMapMessageInboxFilter
                        || 'all';

                    if (
                        ![
                            'all',
                            'unread',
                            'unread-on-map',
                            'on-map',
                        ].includes(
                            nextFilter
                        )
                    ) {
                        return;
                    }

                    activeInboxFilter =
                        nextFilter;

                    inboxScrollTop = 0;
                    restoreInboxScrollOnRender =
                        false;

                    if (messageList) {
                        messageList.scrollTop = 0;
                    }

                    updateInboxFilterUi();

                    if (
                        activeMode === 'inbox'
                        && latestInboxPayload
                    ) {
                        renderInbox(
                            latestInboxPayload
                        );
                    }
                }
            );
        }
    );

    messageList?.addEventListener(
        'keydown',
        (event) => {
            if (activeMode !== 'inbox') {
                return;
            }

            const currentRow =
                event.target.closest(
                    '[data-compact-conversation-id]'
                );

            if (!currentRow) {
                return;
            }

            if (
                ![
                    'ArrowDown',
                    'ArrowUp',
                    'Home',
                    'End',
                ].includes(
                    event.key
                )
            ) {
                return;
            }

            const rows =
                Array.from(
                    messageList.querySelectorAll(
                        '[data-compact-conversation-id]'
                    )
                );

            if (rows.length === 0) {
                return;
            }

            event.preventDefault();

            const currentIndex =
                rows.indexOf(
                    currentRow
                );

            let nextRow =
                currentRow;

            if (event.key === 'Home') {
                nextRow =
                    rows[0];
            } else if (
                event.key === 'End'
            ) {
                nextRow =
                    rows[
                        rows.length - 1
                    ];
            } else if (
                event.key === 'ArrowDown'
            ) {
                nextRow =
                    rows[
                        Math.min(
                            rows.length - 1,
                            currentIndex + 1
                        )
                    ];
            } else if (
                event.key === 'ArrowUp'
            ) {
                nextRow =
                    rows[
                        Math.max(
                            0,
                            currentIndex - 1
                        )
                    ];
            }

            nextRow?.focus();

            nextRow?.scrollIntoView({
                behavior:
                    'smooth',

                block:
                    'nearest',
            });
        }
    );

    messageList?.addEventListener(
        'scroll',
        () => {
            if (
                activeMode === 'inbox'
            ) {
                inboxScrollTop =
                    messageList.scrollTop;

                return;
            }

            if (
                pendingNewMessageCount > 0
                && isNearBottom()
            ) {
                clearNewMessageNotice();

                return;
            }

            updateNewMessageUi();
        },
        {
            passive: true,
        }
    );

    newMessageButton?.addEventListener(
        'click',
        jumpToLatest
    );

    input?.addEventListener(
        'input',
        () => {
            sendTypingPing();
        }
    );

    quickReplyButtons.forEach(
        (button) => {
            button.addEventListener(
                'click',
                () => {
                    if (!input) {
                        return;
                    }

                    input.value =
                        button.dataset
                            .liveMapMessageQuickReply
                        || '';

                    input.focus();

                    sendTypingPing();
                }
            );
        }
    );

    input?.addEventListener(
        'keydown',
        (event) => {
            if (
                event.key === 'Enter'
                && (event.ctrlKey
                    || event.metaKey)
            ) {
                event.preventDefault();
                form?.requestSubmit();
            }
        }
    );

    replyCancel?.addEventListener(
        'click',
        clearReplyTarget
    );

    form?.addEventListener(
        'submit',
        async (event) => {
            event.preventDefault();

            const body =
                input?.value.trim()
                ?? '';

            const hasAttachments =
                Boolean(
                    attachmentInput
                        ?.files
                        ?.length
                );

            if (
                (!body && !hasAttachments)
                || !activeConversation
                || !activeConversation
                    .sendUrl
                || sending
            ) {
                return;
            }

            sending = true;
            setError('');

            const originalText =
                sendButton?.textContent;

            if (sendButton) {
                sendButton.disabled = true;
                sendButton.textContent =
                    'Sending…';
            }

            try {
                const formData =
                    new FormData(form);

                if (body) {
                    formData.set(
                        'body',
                        body
                    );
                } else {
                    formData.delete(
                        'body'
                    );
                }

                const response =
                    await fetch(
                        activeConversation
                            .sendUrl,
                        {
                            method: 'POST',

                            body:
                                formData,

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',
                            },
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    const validationError =
                        payload?.errors
                            ? Object
                                .values(
                                    payload.errors
                                )
                                .flat()
                                .find(
                                    (item) =>
                                        typeof item
                                        === 'string'
                                )
                            : null;

                    throw new Error(
                        validationError
                        || payload?.message
                        || 'Unable to send your message.'
                    );
                }

                if (input) {
                    input.value = '';
                }

                if (
                    typeof attachmentQueue
                        ?.resetAttachmentQueue
                    === 'function'
                ) {
                    attachmentQueue
                        .resetAttachmentQueue();
                }

                clearReplyTarget();
                hideTypingIndicator();

                await loadConversationUpdates({
                    forceBottom: true,
                });
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to send your message.'
                );
            } finally {
                sending = false;

                if (sendButton) {
                    sendButton.disabled =
                        false;

                    sendButton.textContent =
                        originalText
                        || 'Send';
                }

                input?.focus();
            }
        }
    );

    searchToggle?.addEventListener(
        'click',
        () => {
            if (searchOpen) {
                closeSearch({
                    restoreLatest:
                        activeMode
                        === 'search-context',
                });

                return;
            }

            openSearch();
        }
    );

    searchClose?.addEventListener(
        'click',
        () => {
            closeSearch({
                restoreLatest:
                    activeMode
                    === 'search-context',
            });
        }
    );

    searchForm?.addEventListener(
        'submit',
        (event) => {
            event.preventDefault();
            runSearch();
        }
    );

    muteButton?.addEventListener(
        'click',
        async () => {
            if (
                !activeConversation
                    ?.muteUrl
                || muteButton.disabled
            ) {
                return;
            }

            muteButton.disabled = true;

            const csrfToken =
                document.querySelector(
                    'meta[name="csrf-token"]'
                )?.content;

            try {
                const response =
                    await fetch(
                        activeConversation
                            .muteUrl,
                        {
                            method:
                                'PATCH',

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',

                                ...(csrfToken
                                    ? {
                                        'X-CSRF-TOKEN':
                                            csrfToken,
                                    }
                                    : {}),
                            },
                        }
                    );

                const payload =
                    await response.json()
                        .catch(
                            () => ({})
                        );

                if (!response.ok) {
                    throw new Error(
                        payload?.message
                        || 'Unable to update notification settings.'
                    );
                }

                activeConversation.isMuted =
                    Boolean(
                        payload.muted
                    );

                updateMuteButtonUi();
            } catch (requestError) {
                setError(
                    requestError
                        instanceof Error
                        ? requestError.message
                        : 'Unable to update notification settings.'
                );
            } finally {
                muteButton.disabled =
                    false;
            }
        }
    );

    openButtons.forEach(
        (button) => {
            button.addEventListener(
                'click',
                openInbox
            );
        }
    );

    backButton?.addEventListener(
        'click',
        openInbox
    );

    closeButton?.addEventListener(
        'click',
        closeDrawer
    );

    backdrop?.addEventListener(
        'click',
        closeDrawer
    );

    document.addEventListener(
        'keydown',
        (event) => {
            if (
                event.key === 'Escape'
                && !drawer.classList
                    .contains('hidden')
            ) {
                closeDrawer();
            }
        }
    );

    window.addEventListener(
        'festfriends:open-conversation',
        (event) => {
            openConversation(
                event.detail
                || {}
            );
        }
    );

    document.addEventListener(
        'visibilitychange',
        () => {
            if (
                document.visibilityState
                !== 'visible'
            ) {
                return;
            }

            if (
                activeMode === 'conversation'
                && activeConversation
            ) {
                loadConversationUpdates();

                return;
            }

            if (activeMode === 'inbox') {
                loadInbox();
            }
        }
    );
};

document.addEventListener(
    'DOMContentLoaded',
    initializeLiveMapMessageDrawer
);

document.addEventListener(
    'livewire:navigated',
    initializeLiveMapMessageDrawer
);

initializeLiveMapMessageDrawer();
